// src/App.js
import React, { useState, useEffect, useCallback } from "react";
import Header from "./components/Header";
import MainContent from "./components/MainContent";
import Footer from "./components/Footer";
import MobileNavigation from "./components/MobileNavigation";
import CartSideWidget from "./components/CartSideWidget";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css"; // For global styles like .responsive-btn
import GalleryPage from "./pages/GalleryPage";
import { Route, Routes } from "react-router-dom";
import CoursesPage from "./pages/CoursesPage";
import ContactUsPage from "./pages/ContactUsPage";
import AboutUsPage from "./pages/AboutUsPage";
import CheckoutPage from "./pages/CheckoutPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Register from "./pages/Register";
import Login from "./pages/Login";
import ProtectedRoute from "./utils/ProtectedRoute";
import Profile from "./pages/Profile";
import PurchageHistory from "./pages/PurchageHistory";
import RefunfPolicy from "./pages/Refunpolicy";

function App() {
  const [cart, setCart] = useState([]);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isCartWidgetOpen, setIsCartWidgetOpen] = useState(false);
  const [user, setUser] = useState(null);

  const managelogin = (user) => {
    setUser(user);
  };

  // Load cart from localStorage
  useEffect(() => {
    const storedCart = localStorage.getItem("myCart");
    if (storedCart) {
      setCart(JSON.parse(storedCart));
    }
  }, []);

  // Save cart to localStorage
  useEffect(() => {
    localStorage.setItem("myCart", JSON.stringify(cart));
  }, [cart]);

  const formatPrice = (priceStr) => {
    const num = parseFloat(String(priceStr).replace(/[₹,]/g, "")) || 0;
    return num;
  };

  const addToCart = useCallback((product) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find(
        (item) => item.productId === product.productId
      );
      if (existingItem) {
        return prevCart.map((item) =>
          item.productId === product.productId
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
    alert(`🛒 "${product.title}" has been added to your cart.`); // You might want a more subtle notification
  }, []);

  const updateQuantity = useCallback((productId, delta) => {
    setCart((prevCart) => {
      const updatedCart = prevCart
        .map((item) =>
          item.productId === productId
            ? { ...item, quantity: Math.max(0, item.quantity + delta) } // Ensure quantity doesn't go below 0
            : item
        )
        .filter((item) => item.quantity > 0); // Remove item if quantity is 0
      return updatedCart;
    });
  }, []);

  const removeFromCart = useCallback((productId) => {
    setCart((prevCart) =>
      prevCart.filter((item) => item.productId !== productId)
    );
  }, []);

  const cartTotal = cart.reduce(
    (total, item) => total + formatPrice(item.price) * item.quantity,
    0
  );
  const cartItemCount = cart.reduce((count, item) => count + item.quantity, 0); // Or cart.length for unique items

  const toggleMobileNav = () => setIsMobileNavOpen(!isMobileNavOpen);
  const toggleCartWidget = () => setIsCartWidgetOpen(!isCartWidgetOpen);

  return (
    <div className="home wp-singular page-template-default page page-id-13 wp-theme-woodmart theme-woodmart woocommerce-js wrapper-full-width categories-accordion-on woodmart-ajax-shop-on elementor-default elementor-kit-5 elementor-page elementor-page-13">
      <div className="wd-page-wrapper website-wrapper">
        <Header
          cartItemCount={cartItemCount}
          cartTotal={cartTotal}
          toggleMobileNav={toggleMobileNav}
          toggleCartWidget={toggleCartWidget}
          user={user}
        />
        <Routes>
          {/* <MainContent addToCart={addToCart} /> */}
          <Route path="/" element={<MainContent />} />
          <Route path="/gallery" element={<GalleryPage />} />

          <Route
            path="/courses"
            element={<CoursesPage addToCart={addToCart} toggleCartWidget={toggleCartWidget}/>}
          />

          <Route
            path="/productdetails/:productId"
            element={<ProductDetailPage addToCart={addToCart} />}
          />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route element={<ProtectedRoute managelogin={managelogin} />}>
            <Route
              path="/cart_checkout"
              element={
                <CheckoutPage
                  cart={cart}
                  formatPrice={formatPrice}
                  updateQuantity={updateQuantity}
                  toggleCartWidget={toggleCartWidget}
                  isOpen={isCartWidgetOpen}
                  removeFromCart={removeFromCart}
                  cartTotal={cartTotal}
                />
              }
            />
          </Route>
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<Login managelogin={managelogin} />} />
          <Route path="/history" element={<PurchageHistory />} />
          <Route path="/refungpolicy" element={<RefunfPolicy/>}/>
          <Route path="/register" element={<Register />} />
        </Routes>
        <Footer />

        <CartSideWidget
          isOpen={isCartWidgetOpen}
          toggleCartWidget={toggleCartWidget}
          cart={cart}
          updateQuantity={updateQuantity}
          removeFromCart={removeFromCart}
          cartTotal={cartTotal}
          formatPrice={formatPrice}
        />
        <ScrollToTop />
      </div>
    </div>
  );
}

export default App;
